import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ImpactArrowIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() } d="M0,12h9v3l7-6.5L9,2v3H0V12z"/>,
  ]
  getViewBox = () => '0 0 16 16'
}
